import { ReduxUtils } from '../../../dependencies';
import { types } from '../../actions';

const actionTypes = {
    REQUEST: types.FETCH_DASHBOARD_REQUEST,
    SUCCESS: types.FETCH_DASHBOARD_SUCCESS,
    FAILURE: types.FETCH_DASHBOARD_FAILURE,
    CANCEL: types.FETCH_DASHBOARD_CANCEL,
    RESET: types.FETCH_DASHBOARD_RESET,
};

export default ReduxUtils.basicApiReducer({
    actionTypes,
});
